import { render, staticRenderFns } from "./TabSwitcherItem.vue?vue&type=template&id=b5fdbcf2&"
import script from "./TabSwitcherItem.vue?vue&type=script&lang=js&"
export * from "./TabSwitcherItem.vue?vue&type=script&lang=js&"
import style0 from "./TabSwitcherItem.vue?vue&type=style&index=0&id=b5fdbcf2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports